import { from, of } from "rxjs";
import { ofType, combineEpics } from "redux-observable";
import { filter, mergeMap, tap, ignoreElements } from "rxjs/operators";
import { setUserAffinity } from "@ane/exp-data/lib/userDetails/GetUserAffinity.utils";
import { updateManagementGroupActionTypes, updatedManagementGroup, afterUpdatedManagementGroup, updatingManagementGroup, afterUpdateManagementGroupActionType } from "../components/ManagementGroupProvider/ManagementGroupProvider.ducks.js";
import UsersResource from "@ane/exp-data/lib/resources/UserResources";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { loadedUserAffinity } from "@ane/exp-data/lib/userDetails/CurrentUserDetailsActions";
const updateUserManagementGroupEpic = (action$) => {
  return action$.pipe(
    ofType(updateManagementGroupActionTypes.LOAD),
    filter((v) => {
      var _a;
      return !!((_a = v.managementGroup) == null ? void 0 : _a.data);
    }),
    mergeMap((v) => {
      var _a, _b, _c, _d;
      const expUser = {
        UserName: EnvironmentService.getUser().alias,
        WorkspaceId: EnvironmentService.getWorkspaceIdOrDefault((_b = (_a = v.managementGroup) == null ? void 0 : _a.data) == null ? void 0 : _b.workspaceId),
        ManagementGroup: ((_d = (_c = v.managementGroup) == null ? void 0 : _c.data) == null ? void 0 : _d.managementGroup) || "",
        Tenant: ""
      };
      const updateManagementGroupCall = from(UsersResource.updateUserManagementGroupV2(expUser)).pipe(
        mergeMap(() => {
          var _a2;
          const { WorkspaceId, ManagementGroup } = expUser;
          setUserAffinity(WorkspaceId, ManagementGroup);
          const returnActions = [
            updatedManagementGroup((_a2 = v.managementGroup) != null ? _a2 : { data: null, isLoading: false, error: "" }),
            loadedUserAffinity(WorkspaceId, ManagementGroup)
          ];
          if (!!v.onUpdated) {
            returnActions.push(afterUpdatedManagementGroup(v.onUpdated));
          }
          return of(...returnActions);
        })
      );
      const act = updatingManagementGroup();
      return from([updateManagementGroupCall, from([act])]).pipe(mergeMap((x) => x));
    })
  );
};
const afterUpdateUserManagementGroupEpic = (action$) => {
  return action$.pipe(
    ofType(afterUpdateManagementGroupActionType),
    tap((v) => v.onUpdated && v.onUpdated()),
    // ignoreElements: This epic only needs to log LOAD_START, so we don't need to pipe any additional actions
    ignoreElements()
  );
};
const managementGroupProviderEpics = combineEpics(updateUserManagementGroupEpic, afterUpdateUserManagementGroupEpic);
export {
  afterUpdateUserManagementGroupEpic,
  managementGroupProviderEpics as default,
  updateUserManagementGroupEpic
};
//# sourceMappingURL=ManagementGroupProviderEpic.js.map
